<template>
  <div class="q_pad_lr15px">
    <van-tabs swipe-threshold="4" v-model="tabsProps" @click="tabHandler">
      <van-tab title="全部" name="">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" v-if="!showEmpty">
          <van-list
              v-model:loading="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
              error-text="请求失败，点击重新加载">
            <div class="q_vertical_left q_mar_b15px" :key="item.id" v-for="item in list" style="width: 100%"
                 @click="goToFor(item.type,item.id)">
              <div class="q_inlineblock q_po_re">
                <!-- <van-image class="q_formal_img" fit="cover" :src="require('../../assets/image/zs.png')" /> -->
                <van-image class="q_formal_img" fit="cover" :src="require('../../assets/image/zs.png')"/>
              </div>
              <div class="q_mar_l10px q_inlineblock" style="width: 100%;">
                <div class="q_text_m q_bold q_moit2" v-text="item.projectName+'证书'">为志愿者谋保障 “志愿南岸·我来保障”公益众筹活动启动</div>
                <div class="q_mar_t15px q_text_s q_color_gray q_right" v-text="'发放时间 '+item.grantTime"></div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
        <!--空数据-->
        <div class="q_center" style="margin-top: 26vh;" v-if="showEmpty">
          <img src="@/assets/image/none.png" style="width: 26vw;"/>
          <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
        </div>
      </van-tab>
      <van-tab title="活动证书" name="1">

        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" v-if="!showEmpty">
          <van-list
              v-model:loading="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
              error-text="请求失败，点击重新加载">

            <div class="q_vertical_left q_mar_b15px" :key="item.id" v-for="item in list" style="width: 100%"
                 @click="goToFor(item.type,item.id)">
              <div class="q_inlineblock q_po_re">
                <van-image class="q_formal_img" fit="cover" :src="require('../../assets/image/zs.png')"/>
              </div>
              <div class="q_mar_l10px q_inlineblock" style="width: 100%;">
                <div class="q_text_m q_bold q_moit2" v-text="item.projectName+'证书'">“以爱之名 携手同行”助残日志愿服务活动</div>
                <div class="q_mar_t15px q_text_s q_color_gray q_right" v-text="'发放时间 '+item.grantTime"></div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
        <!--空数据-->
        <div class="q_center" style="margin-top: 26vh;" v-if="showEmpty">
          <img src="@/assets/image/none.png" style="width: 26vw;"/>
          <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
        </div>
      </van-tab>
      <van-tab title="募捐证书" name="2">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" v-if="!showEmpty">
          <van-list
              v-model:loading="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
              error-text="请求失败，点击重新加载">

            <div class="q_vertical_left q_mar_b15px" :key="item.id" v-for="item in list" style="width: 100%"
                 @click="goToFor(item.type,item.id)">
              <div class="q_inlineblock q_po_re">
                <van-image class="q_formal_img" fit="cover" :src="require('../../assets/image/zs.png')"/>
              </div>
              <div class="q_mar_l10px q_inlineblock" style="width: 100%;">
                <div class="q_text_m q_bold q_moit2" v-text="item.projectName+'证书'">为志愿者谋保障 “志愿南岸·我来保障”公益众筹活动启动</div>
                <div class="q_mar_t15px q_text_s q_color_gray q_right" v-text="'发放时间 '+item.grantTime">111111111</div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
        <!--空数据-->
        <div class="q_center" style="margin-top: 26vh;" v-if="showEmpty">
          <img src="@/assets/image/none.png" style="width: 26vw;"/>
          <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
        </div>
      </van-tab>
      <van-tab title="培训证书" name="3">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" v-if="!showEmpty">
          <van-list
              v-model:loading="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
              error-text="请求失败，点击重新加载">

            <div class="q_vertical_left q_mar_b15px" :key="item.id" v-for="item in list" style="width: 100%"
                 @click="goToFor(item.type,item.id)">
              <div class="q_inlineblock q_po_re">
                <van-image class="q_formal_img" fit="cover" :src="require('../../assets/image/zs.png')"/>
              </div>
              <div class="q_mar_l10px q_inlineblock" style="width: 100%;">
                <div class="q_text_m q_bold q_moit2" v-text="item.projectName+'证书'">为志愿者谋保障 “志愿南岸·我来保障”公益众筹活动启动</div>
                <div class="q_mar_t15px q_text_s q_color_gray q_right" v-text="'发放时间 '+item.grantTime">111111111</div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
        <!--空数据-->
        <div class="q_center" style="margin-top: 26vh;" v-if="showEmpty">
          <img src="@/assets/image/none.png" style="width: 26vw;"/>
          <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
        </div>
      </van-tab>
    </van-tabs>

  </div>
</template>

<script>
import {listCertificate} from "@/api/certificate";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Myformal',
  props: {
    msg: String
  },
  data() {
    return {
      show: false,
      tabsProps: '',
      finished: false,
      refreshing: false,
      loading: false,
      list: [],
      pageParam: {
        pageNum: 0,
        pageSize: 10,
        type: '',
        state: '1'
      },
      showEmpty: false,
    }
  },
  created() {
    wxCloseShare()
  },
  methods: {
    tabHandler() {
      this.list = [];
      this.onRefresh();
    },
    /**
     * 下拉刷新
     */
    onRefresh() {
      this.pageParam = {
        pageNum: 0,
        pageSize: 10
      }
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    /**
     * 下滑加载更多
     */
    onLoad() {
      this.pageParam.pageNum++;
      this.pageParam.type = this.tabsProps
      if (this.pageParam.pageNum == 1) {
        this.$modal.loading()
      }
      setTimeout(() => {
        listCertificate(this.pageParam).then(res => {
          if (res.total == 0) {
            this.showEmpty = true
          }
          //是否下拉刷新
          if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
          }
          for (let i = 0; i < res.rows.length; i++) {
            this.list.push(res.rows[i]);
          }
          // 加载状态结束
          this.loading = false;

          // 数据全部加载完成
          if (this.list.length >= res.total) {
            this.finished = true;
          }
        }).finally(() => {
          console.log(this.list)
          this.$modal.closeLoading()
        })
      }, 500);
    },
    //全部列表里面的数据触发
    handleDetails(id) {
      this.$router.push({
        path: '/mine/Forspeed', query: {id: id}
      });
    },
    //全部列表里面的数据触发
    goToFor(type,id){
      console.log('type',type)
      if('1'===type){
        //活动证书
        this.goToForacti(id);
      }else if('2'===type){
        //捐赠证书
        this.goToForspeed(id);
      }else if('3'===type){
        //培训证书
        this.goToTrain(id);
      }else{
        alert("未知证书类型");
      }
    },
    //捐赠证书
    goToForspeed(id) {
      this.$router.push({
        path: '/mine/Forspeed', query: {id: id}
      });
    },
    //活动证书
    goToForacti(id) {
      this.$router.push({
        path: '/mine/Foracti', query: {id: id}
      });
    },
    //培训证书
    goToTrain(id) {
      this.$router.push({
        path: '/mine/Train', query: {id: id}
      });
    },
    /**
     * 申请证书
     */
    applyCertificate() {
      this.show = true
    }
  },
}
</script>
<style scoped="scoped">
.q_formal_img {
  width: 60px;
  height: 60px;
}

.q_formal_img >>> .van-image__img {
  border-radius: 5px;
}

>>> .van-tab--active {
  font-weight: 700;
  font-size: 16px;
}

>>> .van-tabs__line {
  background-color: #FF5733;
  height: 6px;
  border-radius: 3px;
  width: 30px;
}

>>> .van-tabs__wrap {
  margin: 10px 0 20px 0;
}
</style>
